import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import GoogleMap from '../components/GoogleMap'

export default function ReferenceDetail() {
  return (
    <>
      <Helmet>
        <title>Reference | Recars ApS</title>
        <meta name="description" content="Se flere af vores projekter og referencer her." />
        <meta property="og:title" content="Reference | Recars ApS" />
        <meta property="og:description" content="Se flere af vores projekter og referencer her." />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/fc45746b-58f8-47db-83c4-feb0973bc76d/placeholder_1.jpg" />
        <link rel="canonical" href="https://recars.dk/reference/" />
      </Helmet>

      {/* Header */}
      <section className="relative bg-dark-950 pt-32 sm:pt-40 lg:pt-44 pb-12 border-b border-dark-800">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12 text-left">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#c5a880]">
            Vores Projekter
          </span>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Reference
          </h1>
          <p className="mt-4 max-w-2xl text-sm text-slate-400">
            Se flere af vores projekter og referencer her. Vi leverer altid højeste kvalitet.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-dark-950 py-20">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Text */}
            <div className="lg:col-span-7 text-left flex flex-col gap-8">
              <div>
                <h2 className="text-2xl font-bold text-white sm:text-3xl">
                  Skræddersyede løsninger
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-slate-300">
                  Vores kunder har alle forskellige behov, og derfor tilbyder vi altid skræddersyede løsninger med udgangspunkt i hver enkelte kundes ønsker. Inden vi går i gang, forventningsafstemmer vi med dig, så vi kan levere et resultat, der lever op til dine forventninger. Se vores projekter og referencer her.
                </p>
              </div>

              <div className="border-t border-dark-800 pt-8">
                <h3 className="text-xl font-bold text-white">
                  Kompetent rådgivning
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-300">
                  Er du i tvivl om, hvilken løsning der er den bedste for dig? Det skal du ikke bekymre dig om. Vi tilbyder kompetent rådgivning i forbindelse med ethvert projekt og holder dig opdateret fra start til slut. Du er i trygge hænder hos os.
                </p>
              </div>

              <div className="mt-4">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 rounded-xl bg-[#c5a880] px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-black hover:bg-[#b39368] transition-all duration-300"
                >
                  Kontakt os for rådgivning
                </Link>
              </div>
            </div>

            {/* Image */}
            <div className="lg:col-span-5">
              <div className="relative overflow-hidden rounded-2xl border border-dark-800 bg-dark-900 p-2 shadow-2xl">
                <img
                  src="https://assets.auxodev.dk/assets/fc45746b-58f8-47db-83c4-feb0973bc76d/placeholder.jpg"
                  alt="Reference"
                  className="w-full h-auto rounded-xl object-cover aspect-square"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <GoogleMap />
    </>
  )
}
